import type { NodeVariant } from '@octopus-do/octopus-project-core'
import { thunkAddArrow } from '@store/migrationActions/thunkActions/thunkArrowsActions'
import {
  thunkAddNodeChildren,
  thunkAddNodeSibling,
  thunkChangeCollapseNode,
  thunkChangeNodesVariant,
  thunkDeleteSelectedNodes,
  thunkDuplicateNode,
} from '@store/migrationActions/thunkActions/thunkNodesActions'
import { useProjectLegacyActions } from '@store/migrationActions/useProjectLegacyActions'
import type { AppState } from '@store/types'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

const useActions = (nodeId: string) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const { updateNodeTitle } = useProjectLegacyActions()

  const onChangeNodeFrame = (variant: NodeVariant) => {
    dispatch(thunkChangeNodesVariant(variant))

    dispatch({
      type: CanvasActionTypes.CLEAR_SELECTED_NODES,
    })
  }

  const onCreateArrow = () => {
    dispatch(thunkAddArrow(nodeId, 'node'))
  }

  const onDeleteNode = () => {
    dispatch(thunkDeleteSelectedNodes())
  }

  const onDuplicateNode = () => {
    dispatch(thunkDuplicateNode(nodeId))
  }

  const onCreateSibling = () => {
    sendGtmEvent(GtmTriggerName.PAGE_ADD)
    dispatch(thunkAddNodeSibling(nodeId))
  }

  const onCreateChild = () => {
    sendGtmEvent(GtmTriggerName.PAGE_ADD)
    dispatch(thunkAddNodeChildren(nodeId))
  }

  const onRenameNode = (name: string) => {
    updateNodeTitle({ id: nodeId, title: name })
  }

  const onCollapse = () => {
    dispatch(thunkChangeCollapseNode(nodeId))
    sendGtmEvent(GtmTriggerName.NODE_COLLAPSE, 'Click to toggle node collapse')
  }

  return {
    onChangeNodeFrame,
    onCreateArrow,
    onDeleteNode,
    onDuplicateNode,
    onCreateSibling,
    onCreateChild,
    onRenameNode,
    onCollapse,
  }
}

export default useActions
